/**
 * @description Component-TradeMobile
 */
import './index.less';

import { FC, useEffect, useMemo } from 'react';

import { useCurrentPairBaseInfoFromUrl, useCurrentPairFromUrl } from '@/features/pair/hook';
import { resetFormByChainId, setTradeFormType } from '@/features/trade/actions';
import { useAppDispatch } from '@/hooks';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';

import { PAIR_PAGE_TYPE } from '@/constants/global';
import { TRADE_OVERLAY_TYPE, TRADE_TYPE } from '@/constants/trade';
import { WrappedBigNumber } from '@/entities/WrappedBigNumber';
import { resetLiquidityFormByChainId } from '@/features/earn/action';
import { useCurrentMarketType } from '@/features/global/hooks';
import { useMarketList } from '@/features/market/hooks';
import { useTradeStore } from '@/features/trade/store';
import { usePollingSingleInstrumentDataOnTradeOrEarn } from '@/hooks/data/usePollingDataOnWorker';
import { usePairCheck } from '@/pages/components/PairInfo/pairCheckHook';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import MobileProfile from '../components/MobileProfile';
import TradeChartsMobile from './TradeChartsMobile';
import TradeDrawerMobile from './TradeDrawerMobile';
import TradeFooterMobile from './TradeFooterMobile';
import TradePairPriceInfoMobile from './TradePairPriceInfoMobile';
import TradeSelectPairMobile from './TradeSelectPairMobile';
interface IPropTypes {
  className?: string;
}
const TradeMobile: FC<IPropTypes> = function () {
  const chainId = useChainId();
  const dispatch = useAppDispatch();
  const userAddr = useUserAddr();
  const { marketPairList, isFetched } = useMarketList(chainId);

  const currentPair = useCurrentPairFromUrl(chainId);

  const { setIsOpenMobileTradeDrawer, showTradeAreaOverlay, setShowTradeAreaOverlay } = useTradeStore();
  const pageTye = useCurrentMarketType();

  const { pairSymbol: symbolFromUrl } = useParams();
  const marketPairListOrdered = useMemo(
    () => _.orderBy(marketPairList, [(p) => WrappedBigNumber.from(p?.volume24hUsd || 0)?.toNumber()], ['desc']),
    [marketPairList],
  );
  const currentBaseInfo = useCurrentPairBaseInfoFromUrl(chainId);
  // const pairFetchingStatus = usePairFetchingStatus(chainId, currentBaseInfo?.id);

  usePollingSingleInstrumentDataOnTradeOrEarn(
    chainId,
    userAddr,
    currentBaseInfo?.instrumentAddr,
    currentBaseInfo?.expiry,
  );

  usePairCheck(
    chainId,
    currentPair?.symbol,
    marketPairListOrdered.map((p) => p.symbol),
    PAIR_PAGE_TYPE.TRADE,
  );
  useEffect(() => {
    chainId && !currentPair && dispatch(resetFormByChainId({ chainId }));
  }, [chainId, dispatch, currentPair]);

  useEffect(() => {
    if (
      isFetched &&
      symbolFromUrl &&
      currentBaseInfo?.symbol?.toLocaleLowerCase() !== symbolFromUrl.toLocaleLowerCase()
    ) {
      const pair = marketPairList.find((p) => p.symbol.toLowerCase() === symbolFromUrl.toLowerCase());
      if (pair) {
        chainId && dispatch(setTradeFormType({ chainId, tradeType: TRADE_TYPE.MARKET }));
      }
    }
    // only these three
  }, [isFetched, symbolFromUrl, currentBaseInfo?.symbol]);

  useEffect(() => {
    if (showTradeAreaOverlay) {
      setIsOpenMobileTradeDrawer(true);
    }

    return () => {
      const shouldKeepDrawerOpen =
        showTradeAreaOverlay === TRADE_OVERLAY_TYPE.ADD_LIQ || showTradeAreaOverlay === TRADE_OVERLAY_TYPE.LEVERAGE;

      if (!shouldKeepDrawerOpen) {
        setIsOpenMobileTradeDrawer(false);
      }
    };
  }, [showTradeAreaOverlay]);

  return (
    <div className="syn-trade-mobile">
      <TradeSelectPairMobile />
      <TradePairPriceInfoMobile currentPair={currentPair} />
      {/* <MobileBanner /> */}
      <TradeChartsMobile />
      <div className="syn-trade-mobile-content">
        <MobileProfile />
      </div>
      <TradeFooterMobile onFooterBtnClick={() => setIsOpenMobileTradeDrawer(true)} />
      <TradeDrawerMobile
        onClose={() => {
          // reset trade form type to market when close drawer
          chainId &&
            dispatch(
              setTradeFormType({
                chainId,
                tradeType: TRADE_TYPE.MARKET,
              }),
            );
          chainId &&
            dispatch(
              resetFormByChainId({
                chainId,
              }),
            );
          setShowTradeAreaOverlay(undefined);

          if (pageTye === PAIR_PAGE_TYPE.EARN) {
            chainId && dispatch(resetLiquidityFormByChainId({ chainId }));
          }
        }}
      />
    </div>
  );
};

export default TradeMobile;
